<template>
    <div>
        <div v-if="loading" class="pa-loading"><img src="/public/img/loading-bar.gif" /></div>

        <div v-else class="u-mt-20" style="padding: 20px 12px;">
            <h4>Quadro de horários</h4>
            <p class="pa-sub">Horário de <strong>{{ turmaNome || $store.state.user.turma_nome }}</strong>.</p>

            <el-alert v-if="erro" type="warning" :closable="false" show-icon :title="erro" class="u-mb-10" />

            <div v-else-if="semQuadro" class="pa-vazio">
                O quadro de horários desta turma ainda não foi publicado pela escola.
            </div>

            <div v-else>
                <div v-for="dia in diasComAula" :key="dia.numero" class="dia-bloco">
                    <div class="dia-titulo">{{ dia.nome }}</div>

                    <el-table :data="dia.aulas" size="mini" stripe style="width:100%"
                              empty-text="Sem aulas neste dia.">
                        <el-table-column label="#" width="46">
                            <template slot-scope="s">
                                <!-- Intervalo NÃO é disciplina: sai marcado, sem ordem de aula. -->
                                <span v-if="s.row.ehIntervalo">—</span>
                                <span v-else>{{ s.row.ordem }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Horário" width="118">
                            <template slot-scope="s">{{ s.row.hora_inicio }} – {{ s.row.hora_fim }}</template>
                        </el-table-column>
                        <el-table-column label="Componente" min-width="150">
                            <template slot-scope="s">
                                <el-tag v-if="s.row.ehIntervalo" size="mini" type="info">Intervalo</el-tag>
                                <strong v-else>{{ s.row.componente || '—' }}</strong>
                            </template>
                        </el-table-column>
                        <el-table-column label="Professor" min-width="140" class-name="hidden-mobile">
                            <template slot-scope="s">
                                <span v-if="s.row.ehIntervalo">—</span>
                                <span v-else>{{ s.row.professor || '—' }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * BLOCO N — item 6. Consome `api/portal/quadro-horarios`, que por sua vez usa o
 * QuadroHorarioService (Bloco F). Este componente NÃO reconstrói quadro a partir de
 * `parametros_diario` nem interpreta `f1`: apenas apresenta o que o backend devolve.
 */
const NOMES_DIA = { 0: 'Domingo', 1: 'Segunda-feira', 2: 'Terça-feira', 3: 'Quarta-feira',
                    4: 'Quinta-feira', 5: 'Sexta-feira', 6: 'Sábado' }

export default {
    name: 'PortalHorarios',

    data: () => ({ loading: true, erro: null, turmaNome: null, dias: [] }),

    computed: {
        semQuadro () { return this.diasComAula.length === 0 },
        diasComAula () { return this.dias.filter(d => d.aulas.length > 0) }
    },

    mounted () { this.carregar() },

    methods: {
        carregar () {
            this.loading = true
            this.erro = null

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/quadro-horarios`,
                             {}, this.$store.getters.getHeaderAuth).then(r => {

                this.loading = false

                const d = r.data || {}
                if (d.erro) { this.erro = d.erro; return }

                this.turmaNome = d.turma || null
                this.dias = this.normalizar(d.quadro)

            }).catch(() => {
                this.loading = false
                this.erro = 'Não foi possível carregar o quadro de horários.'
            })
        },

        /**
         * Adapta o formato do backend para exibição. Só reorganiza — nenhuma regra
         * de horário é decidida aqui.
         */
        normalizar (quadro) {
            const porDia = (quadro && quadro.dias) ? quadro.dias : (quadro || {})
            const saida = []

            Object.keys(porDia || {}).forEach(k => {
                const lista = Array.isArray(porDia[k]) ? porDia[k] : []

                saida.push({
                    numero: Number(k),
                    nome: NOMES_DIA[Number(k)] || `Dia ${k}`,
                    aulas: lista.map(a => ({
                        ordem: a.ordem,
                        hora_inicio: a.hora_inicio,
                        hora_fim: a.hora_fim,
                        componente: a.componente || a.disciplina || null,
                        professor: a.professor || null,
                        // O backend marca o intervalo; o portal não deduz por ausência de componente.
                        ehIntervalo: a.tipo === 'intervalo' || a.intervalo === true
                    }))
                })
            })

            return saida.sort((a, b) => a.numero - b.numero)
        }
    }
}
</script>

<style scoped>
.pa-loading { min-height: 350px; display: flex; justify-content: center; align-items: center; }
.pa-sub { color: #909399; }
.pa-vazio { padding: 26px 12px; text-align: center; color: #909399; background: #fafafa; border-radius: 4px; }
.dia-bloco { margin-bottom: 18px; }
.dia-titulo { font-weight: 600; color: #303133; margin-bottom: 6px; }
@media (max-width: 640px) { .hidden-mobile { display: none !important; } }
</style>
